import { RestUrl } from "../../common/cyan.types";

export class DocsPdfServiceInspectUrl {
  public static inspect: RestUrl = ["GET", "/internal/inspect"];
}
